<template>
	<div class="content-area-wrapper">
		<Dashboard v-if="content == 'dashboard'" />
		<IntroScreen v-if="content == 'intro-screen'" />
		<Module v-if="content == 'module'" />
		<ModuleStats v-if="content == 'moduleStats'" />
	</div>
</template>
<script>
import Dashboard from "./Dashboard.vue";
import ModuleStats from "./ModuleStats.vue";
import IntroScreen from "./IntroScreen.vue";
import Module from "./Module.vue";
export default {
	name: "ContentArea",
	props: [],
	components: {
		Dashboard,
		IntroScreen,
		Module,
		ModuleStats
	},
	computed: {
		content() {
			return this.$store.state.content;
		}
	},
	methods: {},
	mounted() {}
};
</script>